import { useHeaderContext } from '@lingoda/contexts';
import { Box } from '@lingoda/ui';
import type { FC } from 'react';

interface Props {
    useRawHeight?: boolean;
}

export const AppBarGap: FC<Props> = ({ useRawHeight }) => {
    const headerTheme = useHeaderContext();

    return <Box minHeight={useRawHeight ? headerTheme.rawHeight : headerTheme.height} />;
};
